import { MessageManager } from "src/core/streaming/core/messageManager";
import {
  ErrorHandler,
  MetaHandler,
  UpdateHandler
} from "src/core/streaming/core/types";
import { ConfigDDataSource } from "src/core/streaming/pooledDataSource";
import { RefPoint } from "src/gen/schema/schema/schema";
import { SchemaType } from "src/gen/schema/schema_path/schema_path";

import { BaseDataSourceApi } from "./baseDataSourceApi";

class ConfigDApi extends BaseDataSourceApi<ConfigDDataSource> {
  initDataSource(): ConfigDDataSource {
    return new ConfigDDataSource(window.cnc.configDPool);
  }

  subscribeRefPoint(
    fabricId: string,
    onSuccess: UpdateHandler<RefPoint[]>,
    onError: ErrorHandler,
    onMeta?: MetaHandler
  ) {
    return this.getDataSource().subscribe(
      fabricId,
      MessageManager.create({
        objectId: [fabricId],
        types: [SchemaType.RefPointType]
      }),
      MessageManager.transformer((s) => s.refPoint),
      MessageManager.reducer,
      onSuccess,
      onError,
      onMeta
    );
  }
}

const ConfigD = new ConfigDApi();
export { ConfigD };
